import { COLORS } from '@btime/constants'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { HorizontalLine } from '../../../../../../../components/shapes/Line'
import { Title } from '../../../../../../../packages/kiti/components/presentation/Text'
import { useChecklistFormActions, useSelectedQuestion } from '../../../../_form/ChecklistFormHandler'
import Separator from '../../../../../../../packages/kiti/components/helpers/Separator'
import { canRenderInputForType } from '../_helpers/hideInputForType'
import { INTEGRATION_DATA_FIELDS } from '../../../../../../fields/edit/_data/integrationDataFields'
import { useIntegrations } from '../../../../_load/IntegrationsLoader'
import Select from '../../../../../../../packages/kiti/components/form/Select'
import FormItem from '../../../../../../../components/form/FormItem'
import { ALLOWED_QUESTIONS_AND_FIELDS_INTEGRATIONS } from '../../../../../../integrations/_services/services'

const IntegrationSection = () => {
  const { t } = useTranslation('editChecklist')
  const { handleSelectedQuestionChangeOnPath } = useChecklistFormActions()
  const selectedQuestion = useSelectedQuestion()
  const shouldRender = canRenderInputForType(selectedQuestion.questionType.name)
  const shouldRenderIntegration = shouldRender('integration')
  const integrations = useIntegrations()

  const selectedIntegration = selectedQuestion?.data?.selectedIntegrationService

  const availableIntegrationServices = integrations.filter(field =>
    ALLOWED_QUESTIONS_AND_FIELDS_INTEGRATIONS.includes(field.integrationService)
  )

  const integrationFieldsMatch = INTEGRATION_DATA_FIELDS.filter(field =>
    selectedIntegration?.integrationService.includes(field.integrationService)
  )

  const integrationFields = integrationFieldsMatch.map(field => ({
    ...field,
    integrationId: integrations.find(item => item.integrationService === field.integrationService)?.integrationId
  }))

  const handleSelectIntegrationService = value => {
    handleSelectedQuestionChangeOnPath(['data', 'selectedIntegrationService'], value)
    handleSelectedQuestionChangeOnPath(['data', 'integration'], undefined)
  }

  const handleSetIntegration = value => {
    const integrationId = selectedIntegration?.integrationId
    const newValue = { ...value, integrationId }
    handleSelectedQuestionChangeOnPath(['data', 'integration'], newValue)
  }

  if (!shouldRenderIntegration) return false

  return (
    <>
      <Separator weight={6} />
      <Title size="h6" color={COLORS.dark4}>
        {t('integration')}
      </Title>
      <HorizontalLine thin lineColor={COLORS.light2} />
      <Separator weight={2} />
      <FormItem label={t('service')} weight={2}>
        <Select
          options={availableIntegrationServices}
          onChange={handleSelectIntegrationService}
          value={selectedIntegration}
        />
      </FormItem>
      {selectedIntegration && (
        <FormItem label={t('field')}>
          <Select
            options={integrationFields}
            onChange={handleSetIntegration}
            value={selectedQuestion?.data?.integration}
          />
        </FormItem>
      )}
    </>
  )
}

export default IntegrationSection
